import { Directive, HostBinding, HostListener } from '@angular/core';
import * as $ from 'jquery';

@Directive({
    selector: '[appExpandSidebar]'
})

export class AppExpandSidebar {

    @HostBinding('class.isActive') isOpen = false;

    @HostListener('click', ['$event.target']) toggleOpen($event) {
        // console.log('aqui', this.isOpen);
        this.isOpen = !this.isOpen;
        $( document ).ready(() => {
            if (this.isOpen) {
                $('.header').removeClass('slide-open');
                $('.header').addClass('slide-close');

                $('.content').removeClass('slide-open');
                $('.content').addClass('slide-close');

                $('.sidebar').removeClass('slide-sidebar-open');
                $('.sidebar').addClass('slide-sidebar-close');
            } else {
                $('.header').removeClass('slide-close');
                $('.header').addClass('slide-open');

                $('.content').removeClass('slide-close');
                $('.content').addClass('slide-open');

                $('.sidebar').removeClass('slide-sidebar-close');
                $('.sidebar').addClass('slide-sidebar-open');
            }
        });
    }
}
